import { product } from '@/interfaces/product'
import { processGroupRequest } from '@/network/requests/processGroup'
import { productRequest } from '@/network/requests/product'
import { techGroupRequest } from '@/network/requests/techGroup'
import { AxiosResponse } from 'axios'
import moment from 'moment'
import XLSX from 'xlsx'

/**
 * 产品导入校验对象。
 */
interface productImportValidate {
	[propName: string]: string
}

/**
 * 产品导入对象。
 */
interface productImportObject {
	/**
	 * 名称。
	 */
	name: string
	/**
	 * 编号。
	 */
	code: string
	/**
	 * 工艺参数组Id；
	 */
	tech_group_id?: string
	/**
	 * 工艺参数组名称；
	 */
	techGroupName: string
	/**
	 * 工艺参数组Id；
	 */
	process_group_id?: string
	/**
	 * 工序组名称；
	 */
	processGroupName: string
	/**
	 * 创建时间；
	 */
	created_time?: string
	/**
	 * 等级；
	 */
	grade: number
	/**
	 * 备注；
	 */
	remark?: string
	/**
	 *
	 */
	message: string
	/**
	 * 校验结果。
	 */
	validateInfo?: productImportValidate
	/**
	 * 是否出错。
	 */
	hasError: boolean
	/**
	 * 是否合格。
	 */
	isValid: boolean
	/**
	 * 保存结果。
	 */
	saveResult?: string
	/**
	 * 是否保存成功。
	 */
	saved?: boolean
}

/**
 * 产品等级。
 */
export const ProductLevel = {
	/**
	 *
	 */
	data: [] = [
		{
			value: 0,
			label: '特级',
		},
		{
			value: 1,
			label: '一级',
		},
		{
			value: 2,
			label: '二级',
		},
		{
			value: 3,
			label: '三级',
		},
	],

	/**
	 *
	 * @param value
	 */
	getLevelName(value: number): string {
		var first = this.data.find(t => t.value == value)
		if (first) {
			return first.label
		}

		return ''
	},
}

/**
 * 产品数据导入组件。
 */
export class ProductImport {
	/**
	 * 文件对象。
	 */
	inputFile: any

	/**
	 * 产品导入数据结果。
	 */
	dataTable: productImportObject[] = []

	/**
	 * 文件解析完成后的回调函数。
	 */
	analysisCallback: Function

	/**
	 * 通过选择的Excel文件对象进行组件构造。
	 * @param binarryFileString 文件对象。
	 * @param analysisCallback  文件分析完成后的回调函数。
	 */
	constructor(binarryFileString: any, analysisCallback: Function) {
		this.inputFile = binarryFileString
		this.analysisCallback = analysisCallback

		var reader = new FileReader()
		reader.onload = e => this.readerOnload(e, this)
		reader.readAsBinaryString(binarryFileString)
	}

	/**
	 * 进行文件读取。
	 * @param e
	 * @param self
	 */
	private readerOnload(e: ProgressEvent<FileReader>, self: this) {
		var data = e.target?.result
		var wb = XLSX.read(data, {
			type: 'binary',
		})

		var sheet0 = wb.Sheets[wb.SheetNames[0]]

		//使用raw属性，避免日期格式进行转换。
		var array: any[] = XLSX.utils.sheet_to_json(sheet0, { raw: false })
		var list: productImportObject[] = []

		console.log(array)
		for (var item of array) {
			list.push({
				isValid: false,
				name: item['名称'],
				code: item['编号'],
				created_time: item['创建时间'],
				grade: parseInt(item['等级']),
				remark: item['备注'],
				techGroupName: item['工艺参数组'],
				processGroupName: item['工序组'],
				message: '准备导入',
				hasError: false,
				validateInfo: {},
			})
		}

		//执行回调。
		self.analysisCallback(list)

		self.dataTable = list
	}

	/**
	 * 删除一条记录。
	 * @param index
	 */
	deleteRow(index: number): void {
		this.dataTable.splice(index, 1)
	}

	/**
	 * 保存数据。
	 */
	save(): Promise<AxiosResponse<any>> {
		let hasError = this.dataTable.filter(t => t.hasError)

		console.log(this.dataTable)

		if (hasError.length > 0) {
			return Promise.reject('')
		}

		var products: product[] = []
		//遍历数据，换换成产品对象。
		for (let i = 0; i < this.dataTable.length; i++) {
			const t = this.dataTable[i]

			var p = this.getProduct(t)
			products.push(p)
		}

		//上传产品信息。
		return productRequest.uploadBatch(products)

		//记录日志。
	}

	/**
	 * 进行数据校验。
	 */
	async checkData(): Promise<productImportObject[]> {
		//遍历数据。
		var result: productImportObject[] = []
		for (const item of this.dataTable) {
			var t = await this.validate(item)

			result.push(t)
		}

		this.dataTable = result

		return result
	}

	/**
	 * 进行数据校验。
	 * @param p
	 */
	async validate(p: productImportObject): Promise<productImportObject> {
		console.log('进行数据校验')

		p.message = '正在进行名称检查...'
		p.validateInfo = {}
		p.isValid = false

		let p1 = productRequest.queryAll({ name: p.name })
		let p2 = productRequest.queryAll({ code: p.code })
		let p3 = techGroupRequest.queryAll({ name: p.techGroupName })
		let p4 = processGroupRequest.queryAll({ name: p.processGroupName })

		var results = await Promise.all([p1, p2, p3, p4])

		//检查重名。
		var data = results[0]
		if (p.name) {
			if (data.length > 0 || this.dataTable.filter(t => t.name == p.name).length > 1) {
				p.validateInfo['name'] = '名称已存在'
				p.hasError = true
			}
		} else {
			p.validateInfo['name'] = '名称无效'
		}

		//检查编号是否重复。
		var data = results[1]
		if (p.code) {
			if (data.length > 0 || this.dataTable.filter(t => t.code == p.code).length > 1) {
				p.validateInfo['code'] = '编号已存在'
				p.hasError = true
			}
		} else {
			p.validateInfo['name'] = '编号无效'
		}

		//检查工艺参数组
		var techGroups = results[2]
		if (techGroups.length > 0) {
			if (techGroups.length > 1) {
				p.validateInfo['techGroupName'] = `工艺参数组错误，存在多个相同名称的工艺参数组：${p.techGroupName},请检查基础数据的配置。`
				p.hasError = true
			} else {
				p.tech_group_id = techGroups[0]._id?.$oid
			}
		} else {
			p.validateInfo['techGroupName'] = `工艺参数组不存在`
			p.hasError = true
		}

		//检查工序参数组
		var processGroups = results[3]
		if (processGroups.length > 0) {
			if (processGroups.length > 1) {
				p.validateInfo['processGroupName'] = `工序参数组错误，存在多个相同名称的工序参数组：${p.processGroupName},请检查基础数据的配置。`
				p.hasError = true
			} else {
				p.process_group_id = processGroups[0]._id?.$oid
			}
		} else {
			p.validateInfo['processGroupName'] = `工序参数组未找到`
			p.hasError = true
		}

		// 检查备注信息。
		if (p.remark) {
			if (p.remark.length > 150) {
				p.validateInfo['remark'] = `备注信息内容过长`
				p.hasError = true
			}
		}

		//产品等级检测。
		if (isNaN(p.grade)) {
			p.validateInfo['grade'] = '等级文本错误'
		} else {
			if (p.grade < 0) {
				p.grade = 0
			} else if (p.grade > 3) {
				p.grade = 3
			}
		}

		if (p.hasError) {
			p.message = '校验失败，请检查数据。'
		}

		console.log('校验结束', p)

		if (!p.hasError) {
			p.message = '校验通过'
			p.isValid = true
		} else {
			p.isValid = false
		}

		return p
	}

	/**
	 * 进行数据对象转换。
	 * @param p
	 */
	private getProduct(p: productImportObject): product {
		var createTime = moment(p.created_time).valueOf()

		return {
			name: p.name,
			code: p.code,
			tech_group_id: p.tech_group_id,
			created_time: {
				$date: createTime,
			},
			process_group_id: p.process_group_id,
			grade: p.grade,
			remark: p.remark,
			updated: 0,
		}
	}
}
